import axios from 'axios'
import { getAccessToken, getRefreshToken, setAccessToken, setRefreshToken } from './common'
import history from '../history'
import * as API from '../utils/api'

const axiosInstance = axios.create()

axiosInstance.interceptors.request.use(
    (config) => {
        if(!config.headers){
            config.headers = {}
        }
        
        config.headers['Authorization'] = `Bearer ${getAccessToken()}`
        return config
    },
    (error) => {

        return Promise.reject(error)
    }
)

axiosInstance.interceptors.response.use(
    (response) => response,
    async (error) => {

        const config = error.config

        if(error.response?.status === 401 && !config.hasOwnProperty('_retry')){
            // config._retry = true;
            const refresh_token = getRefreshToken()

            if(refresh_token === "undefined"){
                history.push('/login')
                return Promise.reject(error);
            }

            const refreshConfig = {
              headers: {
                  Authorization: `Bearer ${getAccessToken()}`,
              }
            };
            // Call Refresh Token API without using the centralized one to capture authorization error
            return axios.post(API.REFRESH_TOKEN_API, {
                refresh: refresh_token,
            }, refreshConfig).then(res => {
                const { access, refresh } = res.data;
                setAccessToken(access);
                setRefreshToken(refresh);
                return axiosInstance(config)

            }).catch((error) => {
                history.push('/login')
                return Promise.reject(error)
            })

        }

        return Promise.reject(error)

    }
)

export default axiosInstance